module.exports = {"data":{"site":{"siteMetadata":{"title":"Michael Brooks"}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 100
// module chunks = 60335399758886 114276838955818